export default {
      id: "heart-usage",
      viewBox: "0 0 15 13",
      url: __webpack_public_path__ + "img/icons.svg#heart",
      toString: function () {
        return this.url;
      }
    }